import { GET_SUPPLIES_REQUEST, GET_SUPPLIES_SUCCESS, GET_SUPPLIES_ERROR } from "../actions/supply"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const getSupplies = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUPPLIES_REQUEST:
            return {
                ...state,
                loading: true
            }

        case GET_SUPPLIES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case GET_SUPPLIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
}

export default getSupplies
